import Keycloak from "keycloak-js";

// const keycloak = new Keycloak({
//   url: "http://localhost:8080",
//   clientId: "myclient",
//   realm: "myrealm",
// });

export const configureKeycloak = (clientId: string) => {
  return new Keycloak({
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOCK_REALM,
    clientId: clientId
  });
};

const routesClientMap: { [key: string]: string } = {
  "": import.meta.env.VITE_KEYCLOCK_CLIENT_ID,
  "/": import.meta.env.VITE_KEYCLOCK_CLIENT_ID,
  "/hitachi": import.meta.env.VITE_KEYCLOCK_CLIENT_ID_HITACHI,
  "qa-testing": import.meta.env.VITE_KEYCLOCK_CLIENT_ID_HITACHI,
  "/t-mobile": import.meta.env.VITE_KEYCLOCK_CLIENT_ID_T_Mobile
};

const pathname = window.location.pathname;

const pathSegments = pathname.split("/");

const keycloak = configureKeycloak(
  routesClientMap[window.location.pathname] ||
    routesClientMap["/" + window.location.search?.split("org=")[1]] ||
    import.meta.env.VITE_KEYCLOCK_CLIENT_ID
);

export default keycloak;
